export type CheckoutShopMeta = {
  dispensaryId: string;
  publicSlug: string;
};

function storageKey(slug: string): string {
  return `thedrop:cwa:shop:${slug}`;
}

export function writeCheckoutShopMeta(slug: string, meta: CheckoutShopMeta): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(storageKey(slug), JSON.stringify(meta));
  } catch {
    /* quota / private mode */
  }
}

export function readCheckoutShopMeta(slug: string): CheckoutShopMeta | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(storageKey(slug));
    if (!raw) return null;
    const o = JSON.parse(raw) as Partial<CheckoutShopMeta>;
    if (typeof o.dispensaryId === "string" && typeof o.publicSlug === "string") {
      return { dispensaryId: o.dispensaryId, publicSlug: o.publicSlug };
    }
    return null;
  } catch {
    return null;
  }
}
